/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_Q6Inputs */

const es_marketplace_seo_galicia_faq_q6 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Hay barcos con patrón en las Rías Baixas?`)
};

const gl_marketplace_seo_galicia_faq_q6 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai barcos con patrón nas Rías Baixas?`)
};

const en_marketplace_seo_galicia_faq_q6 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are there boats with skipper in Rías Baixas?`)
};

/**
* | output |
* | --- |
* | "Are there boats with skipper in Rías Baixas?" |
*
* @param {Marketplace_Seo_Galicia_Faq_Q6Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_q6 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_Q6Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_Q6Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_q6(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_q6(inputs)
	return es_marketplace_seo_galicia_faq_q6(inputs)
});